/* eslint-disable no-plusplus */
import React from 'react';
import {
  IconButton, makeStyles, Box, useMediaQuery, useTheme,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { Map } from 'common/components/Map';
import useMapLogic from 'views/motorcycle_rental/hooks/useMapLogic';
import MapInfoCardSection from 'views/motorcycle_rental/components/MapInfoCardSection/MapInfoCardSection';

const useStyles = makeStyles((theme) => ({
  MSGeoMap: {
    width: '100%',
    height: '100%',
    minHeight: theme.spacing(50),
    position: 'relative',
  },

  MSCloseBtn: {
    position: 'absolute',
    zIndex: 1,
    width: theme.spacing(5),
    height: theme.spacing(5),
    backgroundColor: theme.palette.common.white,
    color: theme.palette.secondary.main,
    left: theme.spacing(1.5),
    top: theme.spacing(1.5),
    boxShadow: '0px 4px 4px rgb(0 0 0 / 25%)',
    borderRadius: theme.spacing(1),
    '&:hover': {
      backgroundColor: theme.palette.common.white,
      color: theme.palette.secondary.main,
    },
  },
}));

const MapSection = (props) => {
  const {
    rentals, selectedPlace, handleClose, handleBikeCardClick, isWidgetOpen,
  } = props;
  const {
    mapCardData,
    renderMapMarkers,
    handleGoogleMapLoaded,
    handleMapCardClose,
    mapOptions,
  } = useMapLogic({
    rentals,
    selectedPlace,
  });

  const classes = useStyles();
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box id="geoMap" className={classes.MSGeoMap}>
      <IconButton onClick={handleClose} className={classes.MSCloseBtn}>
        <CloseIcon />
      </IconButton>

      <Map
        defaultCenter={{
          lat: 16.213487,
          lng: -118.759664,
        }}
        defaultZoom={6}
        renderMapMarkers={renderMapMarkers}
        onGoogleApiLoaded={({ map, maps }) => handleGoogleMapLoaded(map, maps)}
        mapOptions={mapOptions}
      />
      {mapCardData.open && !isWidgetOpen && (
        <MapInfoCardSection
          handleBikeCardClick={handleBikeCardClick}
          open={mapCardData.open}
          handleClose={handleMapCardClose}
          rentalsItems={mapCardData.rentalsItems}
          containerId={isTablet ? 'geoPage' : 'geoMap'}
        />
      )}
    </Box>
  );
};

export { MapSection };
